<template>
  <div>
    <div class="c">
      <h3>Zhang Jifu</h3>
      <ul>
        <li>
          <a href="https://zhangjifu.cn" target="_blank" rel="noopener">Cn</a>
        </li>
        <li>
          <a href="https://zhangjifu.com" target="_blank" rel="noopener">Com</a>
        </li>
        <li>
          <a href="weixin://" target="_blank" rel="noopener">WeChat</a>
        </li>
        <li>
          <a href="alipays://" target="_blank" rel="noopener">Alipay</a>
        </li>
      </ul>

      <h3>Jifu Zhang</h3>
      <ul>
        <li>
          <a href="https://jifuzhang.cn" target="_blank" rel="noopener">Cn</a>
        </li>
        <li>
          <a href="https://jifuzhang.com" target="_blank" rel="noopener">Com</a>
        </li>
        <li>
          <a href="taobao://s.taobao.com" target="_blank" rel="noopener">Taobao</a>
        </li>
        <li>
          <a href="alipayqr://platformapi/startapp?saId=10000007" target="_blank" rel="noopener">Qr</a>
        </li>
      </ul>

      <h3>Geeph Zhang</h3>
      <ul>
        <li>
          <a href="https://geeph.tech" target="_blank" rel="noopener">Tech</a>
        </li>
        <li>
          <a href="https://geeph.me" target="_blank" rel="noopener">Me</a>
        </li>
        <li>
          <a href="https://geephzhang.com" target="_blank" rel="noopener">Com</a>
        </li>
      </ul>
    </div>

    <div class="footer">
      <a :href="beianLink" rel="noreferrer" target="_blank" class="b" v-if="beianLink">
        <img src="../assets/beian.png" class="badge-icon" alt="" />
        津公网安备{{ beianCode }}号
      </a>
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener" class="b">
        <img src="../assets/icp.png" class="badge-icon" alt="" />
        {{ msg }}
      </a>
    </div>
  </div>
</template>

<script>
import screenfull from "screenfull";
export default {
  name: "mind-less",
  props: {
    msg: String,
    beianLink: String,
    beianCode: String,
  },
  mounted() {
    screenfull.toggle();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.b {
  color: sandybrown;
  font-size: xx-small;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  height: 10px;
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 8px;
}

.badge-icon {
  width: 10px;
  height: 10px;
  margin-right: 4px;
  flex-shrink: 0;
}.c {
  margin: 40px 0;
}

h3 {
  color: antiquewhite;
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
  font-size: x-small;
}
</style>
